import { Report } from '../../../pages/Reports/types/ReportModel';
import {
  OrganizationReportDto,
  OrganizationReportsReply,
} from '../dtos/OrganizationReportsReply';

export const transformOrganizationReportsReply = (
  reply: OrganizationReportsReply,
): Report[] => reply.reports.map(mapOrganizationReportDtoToModel);

const mapOrganizationReportDtoToModel = (
  dto: OrganizationReportDto,
): Report => ({
  id: dto.id,
  reportDateISO: dto.reportDateISO,
  name: dto.name,
  fileType: dto.fileType,
  source: dto.source,
});
